<template>
    <ul :style="{'max-height': getMaxListHeight}">
        <li v-for="category in options" :key="category[idField]">
            <div class="container">
                <span class="truncate headerComponent font-9">
                     {{category[displayField]}}
                </span>
                <tree-dropdown-item :display-field="displayField"
                                    :options="category.childOptions"
                                    :id-field="idField"
                                    :selected-item="selectedItem"
                                    :selected-genre="selectedGenre"
                                    @dropdownLeafSelected="$emit('dropdownTreeSelectedOption', $event)">
                </tree-dropdown-item>
            </div>
        </li>
    </ul>
</template>

<script>
import TreeDropdownItem from './TreeDropdownItem.vue';

export default {
    name: 'TreeDropdown',
    components: { TreeDropdownItem },
    props: {
        options: Array,
        idField: String,
        selectedItem: Object,
        displayField: String,
        selectedGenre: String,
        getMaxListHeight: String
    }
};
</script>

<style scoped lang="scss">
    @import './dropdownStyleGuide';

    .container {
        padding-left: 4px;
        padding-right: 4px;
    }

    .headerComponent {
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 5px 8px 4px 8px;
        text-transform: uppercase;
        color: $light-800;
        background-color: $light-300;
        cursor: default;
        display: block;
    }
</style>
